
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { AzureBlobFSLinkedService } from 'app/model/linkedservice/azure-blob-fs.linkedservice';
import { maxConcurrentConnectionsMetadata, recursiveCheckboxMetadata, copyBehaviorMetadata } from '../consts/metadata-consts';
import { Constants } from 'app/shared/shared-constants';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const azureBlobFSDatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.azureBlobFS.datasetType,
    supportLinkedServiceTypes: [Metamodel.modelFor(AzureBlobFSLinkedService).name],
    displayName: stringResources.AzureBlobFS_DisplayText,
    datasetNamePrefix: 'AzureDataLakeStorageFile',
    datasetKind: 'file',
    isSource: true,
    isSink: true,
    icon: {
        className: 'svg-i-100x100-AzureBlob'
    },
    isFirstClass: true,
    category: ['Azure'],
    supportGetMetadataActivity: true,
    supportIncrementalBinaryCopy: true,
    supportRootFolder: true,
    pathRegex: {
        pattern: Constants.blobContainerNameValidation,
        message: stringResources.CopyWizard_Dataset_ADLSGen2_Sink_ContainerValidationError
    },
    supportDeleteActivity: true,
    copySourceControls: [
        recursiveCheckboxMetadata,
        maxConcurrentConnectionsMetadata
    ],
    copySinkControls: [
        copyBehaviorMetadata,
        maxConcurrentConnectionsMetadata
    ]
};
